import React , {useEffect ,useContext} from 'react'
import HeroSlider from './heroSlider';
import { DeviceContext } from '../photosMain';
import FeatureGrid from './featureGrid';
import ContentBar from './contentBar';
import GallerySection from './gallerySection';
import GallHalfSection from './gallHalfSection';
import LatestList from './latestList';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PageAds from '../../common/pageAds';

const PhotosHome = ({data}) => {

                   const homeData = data?.[0]?.homeData || {}
                   const {mobile,setMobile,containerRef} = useContext(DeviceContext)
                    const d = homeData || {};



    useEffect(() => {
  // ===== Intersection Observer =====
  const elements = document.querySelectorAll('.gallery-section, .sidebar-widget');

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in-view');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  elements.forEach((el) => observer.observe(el));

  // ===== Scroll To Top =====
  const scrollBtn = document.getElementById("scrollTop");

  const handleScrollTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  if (scrollBtn) {
    scrollBtn.addEventListener("click", handleScrollTop);
  }

  // ===== Cleanup =====
  return () => {
    observer.disconnect();

    if (scrollBtn) {
      scrollBtn.removeEventListener("click", handleScrollTop);
    }
  };


}, []);


  return (
    

    
  
   
  <main className="photos-home">
       
     <Helmet><title>Latest Telugu Actress Photos, HD Images, Movie Stills & Galleries 2026 | TeluguOne</title></Helmet>            
     <section className="hero-section">
         <div className="hero-inner">
      
      
        <HeroSlider sliderData={d.homeActress} mobile={mobile} />
     

        <FeatureGrid gridActress={d.homeActress?.[0]} gridActor={d.homeActors?.[0]}
           gridEvent={d.homeEvents?.[0]} gridMovie={d.homeMovies?.[0]}
          />

         
         
        
         </div>
      </section>

   
       
        <ContentBar />




       <div className="content-wrapper">
      <div className="content-area">

       
       
       <GallerySection format={"Actress"} formatData={d.homeActress} catLink={"/pages/actress-1.html"} mobile={mobile} />

        
        
        <div className="two-col-sections">
            <GallHalfSection formatData={d.homeActors}  format={"Actors"} catLink={"/pages/actors-2.html"}  mobile={mobile} />
            <GallHalfSection formatData={d.homeMovies} format={"Movies"} catLink={"/pages/movies-8.html"}   mobile={mobile} />
        </div>

          
      
        <GallerySection format={"Events"} formatData={d.homeEvents} catLink={"/pages/events-10.html"} mobile={mobile} />

       
       <GallerySection format={"Wallpapers"}  catLink={"/pages/wallpapers-9.html"} mobile={mobile} />


        </div>

       
      <aside className="sidebar">

      
        <div className="ad-placeholder sidebar-ad tmdb-ad"><span>Visit TeluguOne Cinema For Latest Movie News Updates</span><a href="https://www.teluguone.com/tmdb/" target="_blank"><img  src="https://www.teluguone.com/tmdb/assets/images/tmdb-english-logo.webp"    alt="" /></a>
         <a href="https://www.teluguone.com/tmdb/" target="_blank"><p >Visit Tmdb</p></a>
        
        </div>

       
        <div className="sidebar-widget">
          <div className="widget-header">
            <h3>Latest Pics</h3>
          </div>
          <LatestList />
        </div>

        
        <div className="sidebar-widget">
          <div className="widget-header">
            <h3>Browse Categories</h3>
          </div>
          <div className="cat-grid">
            <Link to="/pages/actress-1.html" className="cat-btn">Actress</Link>
            <Link to="/pages/actors-2.html" className="cat-btn">Actors</Link>
            <Link to="/pages/events-10.html" className="cat-btn">Events</Link>
            <Link to="/pages/movies-8.html" className="cat-btn">Movies</Link>
            <Link to="/pages/kingsize-11.html" className="cat-btn">Kingsize</Link>
            <Link to="/pages/wallpapers-9.html" className="cat-btn">Wallpapers</Link>
            <Link to="/pages/others-12.html" className="cat-btn">Others</Link>
          </div>
        </div>

       
         <div className="ad-placeholder sidebar-ad">
          <span>Download Teluguone Mobile App</span>
          <img className="tone-app-banner"  src="https://www.teluguone.com/images/toneApp/teluguoneapp_banner.webp"    alt="" />
        
          <div>
             <a href="https://play.google.com/store/apps/details?id=com.teluguone.newsapp" target="_blank"><button type="button" >Android</button></a>
             <a href="https://apps.apple.com/in/app/teluguone/id600801946" target="_blank"><button type="button" className="ios" >Ios</button></a>
         </div>
          

        
        </div>

      </aside>


        </div>

       <PageAds  mobile={mobile} containerRef={containerRef} />
  </main>

  
  
   


      
  
  )
}

export default PhotosHome;
